import React from 'react'
import styles from './DataTableHead.module.scss'

interface DataTableHeadProps {
  children: React.ReactNode
  className?: never
}

export const DataTableHead: React.FC<DataTableHeadProps> = ({ children }) => (
  <thead><tr className={styles.head}>{children}</tr></thead>
)
